import * as React from "react";
import {Divider, Drawer, Theme, Toolbar, Typography, useTheme, darken, lighten} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {Colors, drawerWidth, headerHeight} from "@/styles";
import {useDevertoTheme} from "@/context/ThemeProvider";
import {Link} from "./widgets";
import {FormattedMessage} from "react-intl";
import {useMatches} from "react-router";

const useStyles = makeStyles()((theme: Theme) => {
    const textColor = theme.palette.getContrastText(Colors.DrawerBackground);

    return {
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
        },
        drawerPaper: {
            width: drawerWidth,
            backgroundColor: Colors.DrawerBackground,
            color: darken(textColor, 0.2),
            borderRight: 0,
            "& .MuiListItem-root": {
                fontWeight: "bold",
            },
            "& .Mui-selected": {
                backgroundColor: "transparent",
                color: textColor,
            },
            "& .MuiListItem-button:hover": {
                color: textColor,
                backgroundColor: lighten(Colors.DrawerBackground, 0.2),
            },
        },
    };
});

const Logo = () => {
    const devertoTheme = useDevertoTheme();

    if (devertoTheme.logo != null) {
        return <img src={devertoTheme.logo} alt="domain logo" style={{maxHeight: headerHeight}} />;
    }

    return (
        <Typography variant="h4" noWrap style={{color: "white"}} id="sidebar-concerto">
            <FormattedMessage id="app_title" defaultMessage="Concerto" />
        </Typography>
    );
};

type SidebarFunction = (basePath: string) => React.ReactNode;

const Sidebar = React.memo(() => {
    const {classes} = useStyles();
    const theme = useTheme();
    const matches = useMatches();

    const sidebarMatch = matches
        .slice()
        .reverse()
        .find((match) => match.handle && (match.handle as any).sidebar);
    if (!sidebarMatch) return null;
    const sidebarFunction: SidebarFunction = (sidebarMatch.handle as any).sidebar;

    return (
        <Drawer variant="permanent" className={classes.drawer} classes={{paper: classes.drawerPaper}}>
            <Toolbar
                style={{
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: theme.palette.primary.main,
                    color: "white",
                }}
            >
                <Link to="/">
                    <div style={{height: headerHeight, display: "flex", alignItems: "center"}}>
                        <Logo />
                    </div>
                </Link>
            </Toolbar>
            <Divider />
            {sidebarFunction(sidebarMatch.pathname)}
        </Drawer>
    );
});

export default Sidebar;
